import React from "react";
import { Text, Stack, PrimaryButton } from "office-ui-fabric-react/lib";
import { Card } from "@uifabric/react-cards";
import { GS } from "../../utils/Styles";

export interface Page404Props {}

export interface Page404State {}

class Page404 extends React.Component<Page404Props, Page404State> {
  constructor(props: Page404Props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Stack horizontalAlign="center" verticalAlign="center" verticalFill={true}>
        <Stack.Item>
          <Card className="padding-16" horizontal styles={{ root: { width: 315, ...GS.bgWhite, display: "flex", flexDirection: "column", justifyContent: "center" } }}>
            <Card.Item styles={{ root: { alignSelf: "center" } }}>
              <Text variant="xxLargePlus">
                4
                <span role="img" aria-labelledby="lost">
                  🛑
                </span>
                4
              </Text>
            </Card.Item>
            <Card.Item styles={{ root: { alignSelf: "center" } }}>
              <Text variant="large">No Such page... Lets go home</Text>
            </Card.Item>
            <br />
            <Card.Item styles={{ root: { alignSelf: "center" } }}>
              <PrimaryButton label="home" href="/" color="primary" aria-label="home">
                Home
              </PrimaryButton>
            </Card.Item>
          </Card>
        </Stack.Item>
      </Stack>
    );
  }
}

export default Page404;
